export const marketingConsentPartnersNO = ['uScore', 'LendMe', 'Storebrand'];
